module.exports = __webpack_public_path__ + "static/img/zulu_trade.1a7adac.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/zulu_trade.svg
// module id = uqIj
// module chunks = 4